<template>
  <div class="container error">
    <h1> 404 😞</h1>
  </div>
</template>

<script>

export default {

};

</script>

<style lang="scss" scoped>
  .error {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
    font-size: ms(2);
    text-align: center;
    @include respond-to(medium) {
      font-size: ms(5);
    }
  }
</style>
